import { CookieValueTypes } from "cookies-next";

/**
 * set cookies on the client.
 * the limitation here is that cookies set on the client can not be set as
 * `httpOnly`. Default to short lived cookies that can be echoed back out later
 * on as `httpOnly` cookies so as to prevent manupulation by any javascript
 * (ours or 3rd party!).
 */
export const setCookie = (
    name: string,
    value: CookieValueTypes,
    durationMs = 60000
): void => {
    const expires = new Date(Date.now() + durationMs).toUTCString();
    const { cookieName, secureArgs } = varyCookieOnProtocol(name);
    console.log(cookieName, expires)
    document.cookie = `${cookieName}=${value};expires=${expires};path=/${secureArgs}`;
};

const varyCookieOnProtocol = (name: string): Record<string, string> => {
    const cookieName = resolveActualCookieName(name);
    let secureArgs = ";samesite=Lax";
    if (document.location.protocol === "https:") {
        secureArgs += ";secure=true";
    }
    return { cookieName, secureArgs };
};

/**
 * Get a cookie from the client.
 * https://www.w3schools.com/js/js_cookies.asp
 */

export const getClientCookie = (name: string, useOriginalName?: boolean): string => {
    const cookieName = useOriginalName
        ? name + "="
        : resolveActualCookieName(name) + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === " ") {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length);
        }
    }
    return "{}";
};

export const getFacebookCookies = (): { fbp: string; fbc: string } => {
    // If the facebook cookies are set by Facebook (or are set locally), they do not have the `__Host-` prefix
    let facebookFbpCookie = getClientCookie("_fbp", true);
    let facebookFbcCookie = getClientCookie("_fbc", true);

    // If the Facebook cookies are set by us in a hosted environment, they will have the `__Host-` prefix
    if (facebookFbpCookie === "{}" && facebookFbcCookie === "{}") {
        facebookFbpCookie = getClientCookie("_fbp");
        facebookFbcCookie = getClientCookie("_fbc");
    }

    const fbp = facebookFbpCookie !== "{}" ? facebookFbpCookie : "";
    const fbc = facebookFbcCookie !== "{}" ? facebookFbcCookie : "";
    return { fbp, fbc };
};

const resolveActualCookieName = (cookieName: string): string => {
    return document.location.protocol === "https:"
        ? `__Host-${cookieName}`
        : cookieName;
};
